/**
 * Internal tenant org id: the lowered `org_…` string stored as
 * `tenants.tenantId` and used for rooms, cache keys, CLS `tenantOrgId`,
 * and domain events.
 *
 * WorkOS issues mixed-case org ids. Callers must not invent a different
 * mapping (hyphen-strip, locale lowercasing, round-trip through SQL).
 * Issued casing is stored as `tenants.tenantAuthProviderOrgId` at
 * provisioning and read back only at WorkOS / flag-target boundaries.
 */
export function toInternalTenantOrgId(orgId: string): string {
  return orgId.trim().toLowerCase();
}
